import Component from '../inherited/Component'

class Reveal extends Component {
    constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._options = {...{
            distance: '30px',
            origin: 'bottom',
            delay: 100,
            duration: 1500,
            opacity: 0,
            reset: false,
            showAbove: null,
            showBelow: null,
            mount: true,
            easing: 'cubic-bezier(0.45, 0.02, 0.09, 0.98)',
            afterReveal: el => {
                el.style.removeProperty('transition')
                // el.removeAttribute('data-reveal')
                el.classList.add('revealed')
            }, 
            beforeReveal: el => {
              el.classList.add('reveal-started')
            }
        }, ...this._options}
    }

    async mount () {
        const { default: ScrollReveal } = await import('scrollreveal')
        this._scrollReveal = ScrollReveal

        if (this._options.mount == false) {
          return
        }

        await this.run()
    }

    async run () {
      this._scrollReveal().reveal(this._elem, this._options)

      this._ctx.on('ffc--update-scrollreveal', (state, data) => {
          this._scrollReveal().sync()
      })

      document.addEventListener('shopify:section:unload', e => {
        this._elem.style.removeProperty('transition')
        this._elem.removeAttribute('data-reveal')
        this._elem.style.removeProperty('opacity')
        this._elem.style.removeProperty('transition')
        this._elem.style.removeProperty('visibility')
        this._elem.style.removeProperty('transform')
        this._ctx.emit('ffc--update-scrollreveal')
      })

      document.addEventListener('shopify:section:load', e => {
        this._elem.style.removeProperty('transition')
        this._elem.removeAttribute('data-reveal')
        this._elem.style.removeProperty('opacity')
        this._elem.style.removeProperty('transition')
        this._elem.style.removeProperty('visibility')
        this._elem.style.removeProperty('transform')
        this._ctx.emit('ffc--update-scrollreveal')
      })
    }

    unmount () {
        if (this._scrollReveal) {
            this._scrollReveal().destroy();
        }
    }
}

export default Reveal
